import axios from 'utils/axios';
import { useNavigate } from 'react-router-dom';
import { useCallback, useState } from 'react'
import { IRoute } from './../types/route.interface';

export interface UseRoutesState {
  ready: boolean
  createInProgress: boolean
  createRoute(data: any, sendNotification?: boolean): void
  fetchInProgress: boolean
  fetch(): void
  editInProgress: boolean
  editRoute(data: any, sendNotification?: boolean): void
  getOverriddenDeliveryDrivers(data: any): void
  archiveInProgress: boolean
  archiveRoute(id: any, sendNotification?: boolean): void
  reactivateInProgress: boolean
  reactivateRoute(id: any, sendNotification?: boolean): void
  permanentlyDeleteInProgress: boolean
  permanentlyDeleteRoute(data: any): void
  duplicateInProgress: boolean
  duplicateRoute(data: any): void
  routes: null | IRoute[]
  setRegion(region: number): void
  getRouteById(id: any): void
}

export const useRoutes = (pastRoutes: number, active: boolean = true ) => { //pastRoutes here is a boolean using 0 or 1 (numbers)
  let region: number;

  const navigate = useNavigate();

  const [state, setState] = useState<UseRoutesState>({
    ready: false,
    createInProgress: false,
    createRoute: null,
    fetchInProgress: false,
    fetch: null,
    editInProgress: false,
    editRoute: null,
    getOverriddenDeliveryDrivers: null,
    duplicateInProgress: false,
    duplicateRoute: null,
    archiveInProgress: false,
    archiveRoute: null,
    reactivateInProgress: false,
    reactivateRoute: null,
    permanentlyDeleteInProgress: false,
    permanentlyDeleteRoute: null,
    routes: null,
    setRegion: null,
    getRouteById: null
  })

  const fetch = useCallback(async () => {
    setState(s => ({ ...s, fetchInProgress: true }))

    //grabbing routes
    const response = await axios.get<any>(active ? '/berryAPI/routes' : '/berryAPI/archivedRoutes', {
      params: { pastRoutes, region }
    })

    setState(s => ({
      ...s,
      routes: response.data,
      ready: true,
      fetchInProgress: false
    }))
  }, [setState])

  const setRegion = useCallback(async (newRegion: number) => {
    region = newRegion;
    fetch();
  }, [])

  const createRoute = useCallback(
    async (data: any, sendNotification?: boolean) => {
      setState(s => ({ ...s, createInProgress: true }))
      
      await axios.post('/berryAPI/route/create', data, {
        params: { sendNotification }
      }).then((response)=>{
        if (response.status == 200) {
          navigate('/routes');

        }
      }).catch((error) => {
        // Error
        console.log(error);
        setState(s => ({ ...s, createInProgress: false }))
        throw error;
    });    
    },
    [setState],
  )
    //grabbing route object by id
    const getRouteById = useCallback(async (id: any) => {
      setState(s => ({ ...s, fetchInProgress: true }))
      const response = await axios.get<any>(`/berryAPI/route/${id}`)
      const route = response.data;
      setState(s => ({
        ...s,
        route: route,
        ready: true,
        fetchInProgress: false
      }))
      return route;
    }, [setState])
    
    const editRoute = useCallback(
    async (data: any, sendNotification?: boolean) => {
      setState(s => ({ ...s, editInProgress: true }))
      
      await axios.post('/berryAPI/route/edit', {
        ...data,
        sendNotification: sendNotification
      }, {})
        .then((response)=>{
          if (response.status == 200) {
            navigate('/routes');
          }
        }).catch((error) => {
          // Error
          console.log(error);
          setState(s => ({ ...s, editInProgress: false }))
          throw error;
      });
    },
    [setState],
  )
  
  const getOverriddenDeliveryDrivers = useCallback(
  async (data: any) => {
    setState(s => ({ ...s, editInProgress: true }))
    
    return await axios.post('/berryAPI/route/getPotentialOverriddenDeliveryDrivers', data, {})
      .then((response)=>{
        if (response.status == 200) {
          return response.data.OverriddenDeliveryDrivers;
        }
      }).catch((error) => {
        // Error
        console.log(error);
        setState(s => ({ ...s, editInProgress: false }))
        throw error;
    });
  },
  [setState],
) 

    const archiveRoute = useCallback(
    async (id: any, sendNotification?: boolean) => {
      setState(s => ({ ...s, archiveInProgress: true }))
      
      await axios.post('/berryAPI/route/delete', {
        sendNotification: sendNotification
      }, {
        params: {id}
      })
    
      setState(s => ({ ...s, archiveInProgress: false }))
      fetch(); //to refresh routes
    },
    [setState],
  )

  const reactivateRoute = useCallback(
    async (id: any, sendNotification?: boolean) => {
      setState(s => ({ ...s, reactivateInProgress: true }))
      
      await axios.post('/berryAPI/route/reactivate',{}, {
        params: {id, sendNotification}
      })
    
      setState(s => ({ ...s, reactivateInProgress: false }))
      fetch(); //to refresh routes
    },
    [setState],
  )

  const permanentlyDeleteRoute = useCallback(
    async (id: any) => {
      setState(s => ({ ...s, permanentlyDeleteInProgress: true }))
      
      await axios.post('/berryAPI/route/permanantDelete',{}, {
        params: {id}
      })

      setState(s => ({ ...s, permanentlyDeleteInProgress: false }))
      fetch(); //to refresh routes
    },
    [setState],
  )

  const duplicateRoute = useCallback(
    async (id: any) => {
      setState(s => ({ ...s, duplicateInProgress: true }))
      
      await axios.post('/berryAPI/route/duplicate',{}, {
        params: {id}
      })
    
      setState(s => ({ ...s, duplicateInProgress: false }))
      fetch(); //to refresh routes
    },
    [setState],
  )

  return { ...state, fetch, setRegion, editRoute, getOverriddenDeliveryDrivers, createRoute, duplicateRoute, archiveRoute, reactivateRoute, permanentlyDeleteRoute, getRouteById }
}
